import Component from 'vue-class-component'
import { Prop, Vue } from 'vue-property-decorator'
import { recordFinishTime } from '../../../../service/platform'
import { RecordData } from '../../types/task'

@Component
export class Record extends Vue {
  public async getFinishTime(data: RecordData) {
    await recordFinishTime(data)
  }
}
